import { useUnit } from 'effector-react'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { $creatorId } from '@/models/creators.ts'
import { rebillMessageService } from '@/modules/creator-settings/rebill-messages/service/rebill-message.ts'
import type { RebillMessage } from '@/modules/creator-settings/rebill-messages/types.ts'
import { useSettingsContext } from '@/modules/creator-settings/state/SettingsProvider.tsx'
import { getErrorMessage, handleError } from '@/utils/error'

export function useCreateRebillMessageMutation() {
  const toast = useToast()
  const client = useQueryClient()
  const creatorId = useUnit($creatorId)
  const { settingsSortOptions } = useSettingsContext()

  return useMutation(
    (rebillMessageData: RebillMessage) => {
      if (!creatorId) {
        throw new Error('Creator not selected')
      }

      return rebillMessageService.create(creatorId, rebillMessageData)
    },
    {
      onSuccess: () => {
        toast.success('The message was created')
        client.invalidateQueries(['settings', creatorId, settingsSortOptions])
      },
      onError: (error) => {
        const detail = getErrorMessage(error)
        const text = detail?.toLowerCase().includes('timeframe')
          ? detail
          : 'Failed to create the message.'

        handleError(text)
      },
    },
  )
}
